// Per-tenant terminology (tenants.settings.terminology). Pure helpers, no React.
// DEFAULT_TERMS MUST equal server/services/terminologyService.js DEFAULT_TERMS.
export const DEFAULT_TERMS = {
  client: { singular: 'Client', plural: 'Clients' },
  affiliate: { singular: 'Affiliate', plural: 'Affiliates' },
  department: { singular: 'Department', plural: 'Departments' },
  location: { singular: 'Property', plural: 'Properties' },
};
export const TERM_KEYS = Object.keys(DEFAULT_TERMS);

const isNonEmptyString = (v) => typeof v === 'string' && v.trim() !== '';

// Tolerant merge of a stored/raw map over the defaults. Never throws.
export function resolveTerms(raw) {
  const out = {};
  TERM_KEYS.forEach((k) => { out[k] = { ...DEFAULT_TERMS[k] }; });
  if (raw && typeof raw === 'object' && !Array.isArray(raw)) {
    TERM_KEYS.forEach((k) => {
      const e = raw[k];
      if (e && typeof e === 'object' && isNonEmptyString(e.singular) && isNonEmptyString(e.plural)) {
        out[k] = { singular: e.singular.trim(), plural: e.plural.trim() };
      }
    });
  }
  return out;
}

// Lowercase for mid-sentence use, but keep acronyms ("LLC", "LLCs") intact.
export function lowerTerm(s) {
  if (typeof s !== 'string') return s;
  return /[A-Z]{2}/.test(s) ? s : s.toLowerCase();
}

// t('client') / t('client.singular') / t('client.plural', { lower: true })
export function makeT(terms) {
  return (path, { lower } = {}) => {
    if (typeof path !== 'string') return path;
    const [key, form = 'singular'] = path.split('.');
    const entry = (terms && terms[key]) || DEFAULT_TERMS[key];
    if (!entry || (form !== 'singular' && form !== 'plural')) return path;
    const word = entry[form];
    return lower ? lowerTerm(word) : word;
  };
}

// Display text for a navigation key. The key itself is never changed.
export function navDisplayLabel(label, t) {
  switch (label) {
    case 'Clients': return t('client.plural');
    case 'Client Bill Rates': return `${t('client.singular')} Bill Rates`;
    case 'Affiliates': return t('affiliate.plural');
    case 'Departments': return t('department.plural');
    default: return label;
  }
}
